const MissingSeatMapLogo = () => (
  <div className="flex flex-col items-center gap-3 text-primary-500">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
      width="120"
      height="120"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <ellipse cx="60" cy="100" rx="50" ry="8" />
      <path d="M14 100 C14 60, 30 30, 60 30 C90 30, 106 60, 106 100" />
      <path d="M24 100 C24 66, 38 40, 60 40 C82 40, 96 66, 96 100" />
      <path d="M34 100 C34 72, 46 50, 60 50 C74 50, 86 72, 86 100" />
      <circle cx="60" cy="28" r="3" fill="currentColor" />
    </svg>
    <div className="text-base font-semibold">Seating chart coming soon</div>
    <div className="text-sm font-normal text-gray-600">
      We&apos;re fetching seats for this event — check back shortly.
    </div>
  </div>
);

export default MissingSeatMapLogo;
